import { DatePipe } from '@angular/common';
import {
  AfterViewInit,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import dayjs from 'dayjs/esm';
// import { NotificationModel } from 'src/app/Models/notification.model';
import { CommonService, SiteService } from 'src/app/services/index';
import {
  AlertService,
  ConfirmationDialog,
  Constants,
  DateService
} from 'src/app/shared/index';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  displayedColumns = [
    'select',
    'refNo',
    'criticalityLevel',
    'loadName',
    'parameter',
    'ConditionwithValue',
    'firstStartTime',
    'occurrenceCounter',
    'lastStartTime',
    'lastEndTime'
  ];
  faultdisplayedColumns = [
    'slno',
    'faultname',
    'loadname',
    'starttime',
    'endtime',
    'status'
  ];
  faultdata: MatTableDataSource<NotificationModel>;
  dataSource: MatTableDataSource<NotificationModel>;
  public faultarray: any;
  public pageSize = 10;
  public currentPage = 0;
  public totalSize = 0;
  // selection: SelectionModel<NotificationModel> = new SelectionModel<NotificationModel>(true, [ELEMENT_DATA[3]]);

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Input() siteId: string;

  notificationForm: any = {
    issuedAlertAll: false,
    selectedIssuedAlerts: []
  };

  issuedAlerts: any;
  generatedFaults: any;
  useSlideoverSidebarMode = false;
  selected: any;
  alertType: any;
  notificationDateRange: any;
  notificationDefaultQuery = true;
  alwaysShowCalendars: boolean;
  ranges = {
    Yesterday: [dayjs().subtract(1, 'days'), dayjs().subtract(1, 'days')],
    'Last 7 days': [dayjs().subtract(6, 'days'), dayjs()],
    'Last 30 days': [dayjs().subtract(29, 'days'), dayjs()],
    'This month': [dayjs().startOf('month'), dayjs().toDate()]
  };
  operators = [
    { value: '=', text: 'Equal to' },
    { value: '!=', text: 'Not Equal to' },
    { value: '>', text: 'Greater Than' },
    { value: '<', text: 'Less Than' },
    { value: '>=', text: 'Greater Than or equal to' },
    { value: '<=', text: 'Less Than or equal to' }
  ];

  langData: any;

  constructor(
    private router: Router,
    private dateService: DateService,
    private siteService: SiteService,
    private alertService: AlertService,
    private commonService: CommonService,
    private datePipe: DatePipe,
    public dialog: MatDialog,
    private activeRoute: ActivatedRoute,
    route: ActivatedRoute,
    public translate: TranslateService
  ) {
    this.alwaysShowCalendars = true;
    this.siteId = this.activeRoute.snapshot.queryParams['siteId']; // 'JAPBOSCH30201064';
    this.alertType = this.activeRoute.snapshot.queryParams['alertType'];
    if (this.alertType != 'Solar') {
      this.alertType = 'Other';
    }

    this.translate.stream('notifications').subscribe((subStream: any) => {
      this.langData = subStream;
    });
  }

  ngOnInit() {}

  /**
   * Set the paginator after the view init since this component will
   * be able to query its view for the initialized paginator.
   */
  ngAfterViewInit() {
    // this.dataSource.paginator = this.paginator;
    // this.faultdata.paginator = this.paginator;
  }

  ngOnDestroy() {
    // reset pageSize because same service instance is used in other examples
  }

  notifications() {
    const t = this;

    const fromDate =
      t.notificationDefaultQuery === true
        ? undefined
        : dayjs(
            t.notificationDateRange.startDate
              ? t.notificationDateRange.startDate.valueOf()
              : ''
          )
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss');

    const toDate =
      t.notificationDefaultQuery === true
        ? undefined
        : dayjs(
            t.notificationDateRange.endDate
              ? t.notificationDateRange.endDate.valueOf()
              : ''
          )
            .endOf('day')
            .format('YYYY-MM-DD HH:mm:ss');

    t.notificationForm = {
      issuedAlertAll: false,
      selectedIssuedAlerts: []
    };
    t.siteService
      .fetchIssuedAlerts(t.siteId, fromDate, toDate, this.alertType)
      .subscribe((data) => {
        let i = 0;

        this.issuedAlerts = data.map(function (item) {
          i = i + 1;
          return {
            id: i.toString(),
            rId: item.rId,
            isRead: item.isRead,
            refNo: item.refNo,
            criticalityLevel: item.criticalityLevel,
            loadName: item.alertConditions[0].load.name,
            parameter: item.alertConditions[0].parameter,
            conditionOperator: item.alertConditions[0].conditionOperator,
            conditionValue: item.alertConditions[0].conditionValue,
            firstStartTime: item.firstStartTime,
            occurrenceCounter: item.occurrenceCounter,
            lastStartTime: item.lastStartTime,
            lastEndTime: item.lastEndTime
          };
        });
        t.dataSource = new MatTableDataSource<NotificationModel>(
          this.issuedAlerts
        );
        this.dataSource.paginator = this.paginator;
      });
    t.siteService
      .fetchGeneratedFaults(t.siteId, fromDate, toDate)
      .subscribe((data) => {
        let i = 0;
        this.generatedFaults = data.map(function (item) {
          i = i + 1;
          return {
            slno: i.toString(),
            faultname: item.faultname,
            loadname: item.deviceName,
            starttime: item.starttime,
            endtime: item.endtime,
            status: item.faultStatus
          };
        });
        this.faultarray = this.generatedFaults;
        this.totalSize = this.faultarray.length;
        this.faultiterator();
        this.faultdata.paginator = this.paginator;
      });
  }
  public faulthandlePage(e: any) {
    this.currentPage = e.pageIndex;
    this.pageSize = e.pageSize;
    this.faultiterator();
  }
  private faultiterator() {
    const end = (this.currentPage + 1) * this.pageSize;
    const start = this.currentPage * this.pageSize;
    const part = this.faultarray.slice(start, end);
    this.faultdata = part;
  }

  markAlerts(isRead) {
    const t = this;
    if (t.notificationForm.selectedIssuedAlerts.length > 0) {
      t.siteService
        .setAlertIsReadByRIds(t.notificationForm.selectedIssuedAlerts, isRead)
        .subscribe((data) => {
          if (data === true) {
            this.alertService.message = this.translate.instant(
              Constants.MESSAGE.Save_success
            );
            this.alertService.showSuccess(this.alertService.message);
            t.notifications();
          } else {
            this.alertService.message = this.translate.instant(
              Constants.MESSAGE.Save_failure
            );
            this.alertService.showError(this.alertService.message);
          }
        });
    }
  }

  exportIssuedAlerts() {
    const t = this;
    if (
      t.notificationDateRange.startDate === null &&
      t.notificationDateRange.endDate === null
    ) {
      return;
    }
    const fromDate =
      t.notificationDefaultQuery === true
        ? undefined
        : t.transformDate(
            t.notificationDateRange.startDate.valueOf(),
            Constants.DATE.DATE_FORMAT
          );

    const toDate =
      t.notificationDefaultQuery === true
        ? undefined
        : t.transformDate(
            t.notificationDateRange.endDate.valueOf(),
            Constants.DATE.DATE_FORMAT
          );
    const url =
      t.siteService.getExportIssuedAlertsUrl() +
      '/' +
      t.siteId +
      '/' +
      fromDate +
      '/' +
      toDate +
      '/' +
      Constants.ALERT_FOR_TYPE.SOLAR;
    window.open(url, '_self');
  }

  deleteAlerts() {
    const t = this;
    if (t.notificationForm.selectedIssuedAlerts.length > 0) {
      const dialogRef = this.dialog.open(ConfirmationDialog, {
        width: '500px'
      });
      dialogRef.componentInstance.confirmMessage = this.translate.instant(
        Constants.MESSAGE.Delete_Alerts
      );
      dialogRef.afterClosed().subscribe((result) => {
        if (result === true) {
          t.siteService
            .deleteIssuedAlertByRIds(t.notificationForm.selectedIssuedAlerts)
            .subscribe((data) => {
              if (data === true) {
                this.alertService.message = this.translate.instant(
                  Constants.MESSAGE.Delete_success
                );
                this.alertService.showSuccess(this.alertService.message);
                t.notifications();
              } else {
                this.alertService.message = this.translate.instant(
                  Constants.MESSAGE.Delete_failure
                );
                this.alertService.showError(this.alertService.message);
              }
            });
        }
      });
    }
  }

  checkAllIssuedAlert(event) {
    if (this.notificationForm.issuedAlertAll) {
      this.notificationForm.selectedIssuedAlerts = this.issuedAlerts.map(
        function (item) {
          item.select = true;
          return item.rId;
        }
      );
    } else {
      this.issuedAlerts.map(function (item) {
        item.select = false;
      });
      this.notificationForm.selectedIssuedAlerts = [];
    }
  }

  checkForAllIssuedAlert() {
    if (this.issuedAlerts.length > 0) {
      const index = this.issuedAlerts.findIndex(
        (item) => item.select === false
      );
      this.notificationForm.issuedAlertAll = index >= 0 ? false : true;
    }
  }

  changeDateRangeForNotification() {
    if (
      dayjs(this.notificationDateRange.endDate).diff(
        dayjs(this.notificationDateRange.startDate),
        'days'
      ) >= 31
    ) {
      this.commonService.showDialogMessage(
        this.translate.instant(Constants.DATE_LIMIT_31_DAYS)
      );
      return;
    }

    if (
      this.commonService.isLaterThanCurentDate(
        this.notificationDateRange.endDate
      )
    ) {
      this.commonService.showDialogMessage(
        this.translate.instant(Constants.FUTURE_DATE_NOT_ALLOW)
      );
      return;
    }
    this.notificationDefaultQuery = false;
    this.notifications();
  }

  transformDate(date: any, format: string): string {
    return this.datePipe.transform(date, format) || '';
  }
  onClick(event) {
    const rId = event.source.value;
    const t = this;
    const index = t.notificationForm.selectedIssuedAlerts.findIndex(
      (value) => value === rId
    );
    const item = this.issuedAlerts.find((value) => value.rId === rId);
    item.select = !item.select;
    if (index >= 0) {
      t.notificationForm.selectedIssuedAlerts.pop(rId);
    } else {
      t.notificationForm.selectedIssuedAlerts.push(rId);
    }
    t.checkForAllIssuedAlert();
  }
}
export interface NotificationModel {
  id?: string;
  rId?: string;
  isRead?: boolean;
  refNo?: string;
  criticalityLevel?: string;
  loadName?: string;
  parameter?: string;
  ConditionwithValue?: string;
  firstStartTime?: string;
  occurrenceCounter?: string;
  lastStartTime?: string;
  lastEndTime?: string;
  slno?: string;
  faultname?: string;
  loadname?: string;
  starttime?: string;
  endtime?: string;
  status?: string;
}
